import { boolean, object, string } from 'yup';
import { TFunction } from 'i18next';

import { requiredDateDdMmYyyyField, requiredSigningTimeField, requiredString } from 'common/validation';

export function makeConsultantConfirmationSchema(t: TFunction) {
  return object().shape({
    a: object().shape({
      a: boolean().required(t('form.required')),
      b: boolean().required(t('form.required')),
      c: boolean().required(t('form.required')),
      d: boolean().required(t('form.required')),
    }),
    b: object().shape({
      place: requiredString(t),
      date: requiredDateDdMmYyyyField(t),
      interviewDuration: requiredString(t),
      attendants: requiredString(t),
      city: requiredString(t),
    }),
    c: object().shape({
      place: requiredString(t),
      date: requiredDateDdMmYyyyField(t),
      interviewDuration: requiredString(t),
      attendants: requiredString(t),
      time: requiredSigningTimeField(t),
      city: requiredString(t),
    }),
  });
}
